export enum Device {
  TouchDevice = '(pointer: coarse)'
}
